import http from '@/utils/http'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/"
// get请求
export function addInstructional(data){
    return http.post('/research/researchInfo/portalAdd',data)
}
// 活动，任务获取群组
export function getgroupOne(param){
    return http.get('/group/info/selectMyJoinGroupOneNoPage',param)
}
export function getgroup(param){
    return http.get('/group/info/selectMyManageGroupNoPage',param)
}
// 教学获取群组
export function getgroup1(param){
    return http.get('/group/info/selectMyJoinGroupNoPage1',param)
}
// 教学获取群组
export function getgroup2(param){
    return http.get('/group/info/selectMyJoinGroupNoPage1',param)
}
// 教学获取群组---自己所在群组所在共同体所包含的所有群组
export function getgroupcommon(param){
    return http.get('/group/info/selectMyJoinCommonGroupNoPage',param)
}
// 教学列表
export function getInstructional(param){
    return http.get('/research/researchInfo/portalList',param)
}
// 教学详情
export function instructionalDetail(researchId){
    return http.get('/research/researchInfo/portal/' + researchId)
}
// 学习记录
export function getHistoryList(param){
    return http.get('/video/watchHistory/myList',param)
}
// 查询视频业务扩展(系统上传)列表
export function listVideoExpandadmin(param){
    return http.get('/videoBusiness/videoExpandadmin/getVideoSearchList',param)
}

//学习中心 我的课例list查询接口 getMyVideoList
export function getMyVideoList(param){
    return http.get('/videoBusiness/videoExpandadmin/getMyVideoList',param)
}
//学习中心 我的课例数量查询接口 getMyVideoList
export function getMyVideoCount(param){
    return http.get('/videoBusiness/videoExpandadmin/getMyVideoCount',param)
}

// 视频子集列表
export function listVideoChildPageList(param){
    return http.get('/video/videoInfo/getChildListByVideoId',param)
}
export function listVideoChildList(param){
    return http.get('/video/videoInfo/getAllChildListByVideoId',param)
}
// 查询视频业务扩展(系统上传)详细
export function getVideoExpandadmin(businessVideoId){
    return http.get('/videoBusiness/videoExpandadmin/'+ businessVideoId)
}
// 新增视频业务扩展(系统上传)
export function addVideoExpandadmin(data){
    return http.post('/videoBusiness/videoExpandadmin/portalAdd',data)
}
// 删除教学列表
export function deleteInstructional(researchId){
    return http.delete('/research/researchInfo/portal/' + researchId)
}
// 学习笔记
export function getNotesList(param){
    return http.get('/videoBusiness/businessCommentsExpand/getMyStudyNotesList',param)
}
// 互动随笔
export function getEssayList(param){
    return http.get('/videoBusiness/businessCommentsExpand/getMyComments',param)
}
// 删除随笔
export function deleteEssay(businessCommentsIds){
    return http.delete('/videoBusiness/businessCommentsExpand/portal/'+ businessCommentsIds)
}
// 隐藏随笔
export function editEssay(data){
    return http.put('/video/videoComments/portalEdit',data)
}

// 我的收藏
export function myCollectionList(param){
    return http.get('/video/favoritesRecords/myList',param)
}
// 我的课例查看
export function getLessionInfo(businessVideoId){
    return http.get('/videoBusiness/videoExpandadmin/getPortalInfo/'+businessVideoId)
}
// 我的课例删除
export function deleteLession(businessVideoId){
    return http.delete('/videoBusiness/videoExpandadmin/portal/'+businessVideoId)
}
// 我的任务新增
export function addTask(data){
    return http.post('/mission/missionInfo/portalAdd',data)
}
// 我的任务列表
export function TaskList(param){
    return http.get('/mission/missionInfo/myList',param)
}
// 视频类型下拉框数据
export function moduleList(param){
    return http.get('/businessType/moduleType/studyFindModel',param)
}
// 选择课程
export function findVideo(param){
    return http.get('/video/videoInfo/findVideo',param)
}
// 教学设计修改
export function editInstructional(data){
    return http.put('/research/researchInfo/portalEdit',data)
}

// 教学设计修改群组
export function editInstructionalGroup(data){
    return http.put('/research/researchInfo/portalEditGroup',data)
}

// 我的课例修改
export function editLession(data){
    return http.put('/videoBusiness/videoExpandadmin/portalEdit',data)
}

// 我的课例修改群组
export function editLessionGroup(data){
    return http.put('/videoBusiness/videoExpandadmin/portalEditGroup',data)
}

// 我的任务详情
export function mytaskInfo(missionId){
    return http.get('/mission/missionInfo/portal/' + missionId)
}

// 我的任务修改
export function editMyTask(data){
    return http.put('/mission/missionInfo/portalEdit',data)
}
// 我的任务删除
export function deleteTask(missionIds){
    return http.delete('/mission/missionInfo/portal/'+missionIds)
}
// 完成任务
export function tobanli(data){
    return http.put('/mission/missionUser/portalEdit',data)
}

// 我的审核列表
export function getapproveList(auditUserId,auditState,param){
    return http.get('/main/userPage/getMyAuditInfoList/' + auditUserId + '/' + auditState,param)
}

// 我的审核任务详情
export function getshTaskDetail(userMissionId){
    return http.get('/mission/missionUser/portal/' + userMissionId)
}
// 我的任务完成情况
export function getcomplete(missionId){
    return http.get('/mission/missionUser/portal/missionUserList/' + missionId)
}
// 审批
export function isApprove(data){
    return http.put('/main/userPage/schoolAudit',data)
}
// 审批评论详情
export function plDetail(businessCommentsId){
    return http.get('/videoBusiness/businessCommentsExpand/portal/' + businessCommentsId)
}
// 任务tab数量
export function taskNum(teacherId,param){
    return http.get('/mission/missionInfo/getMyMissionCount/' + teacherId,param)
}
// 教研总结/教学设计/教学总结/我的课例tab数量
export function lessionNum(param){
    return http.get('/main/userPage/getMyAuditCount',param)
}
// 互动随笔tab数量
export function commentsNum(param){
    return http.get('/videoBusiness/businessCommentsExpand/getMyCommentsCount',param)
}
// 2+2反馈tab数量
export function fankuiNum(param){
    return http.get('/videoBusiness/businessCommentsExpand/study/count',param)
}
// 我的收藏tab数量
export function collecteNum(userId){
    return http.get('/video/favoritesRecords/getMyVideoFavoritesRecordsCount/'+userId)
}
// 待办列表
export function doList(auditUserId,param){
    return http.get('/main/userPage/getMyTransactInfoToDosList/'+auditUserId,param)
}
// 已办列表
export function doneList(auditUserId,param){
    return http.get('/main/userPage/getMyTransactInfoDoneList/'+auditUserId,param)
}
// 待办已办数量
export function doNum(auditUserId){
    return http.get('/main/userPage/getMyTransactInfoToDosCount/'+auditUserId)
}
// 我的空间信息
export function teacherInfo(tid){
    return http.get('/teacher/teacher/portal/'+tid)
}
// 修改我的空间信息
export function editInfo(data){
    return http.put('/teacher/teacher/portalEdit',data)
}
// 获取学科列表
export function subject(param){
    return http.get('/businessType/subjectType//listAll')
}
// 修改密码
export function editPwd(data){
    return http.put('/system/user/profile/updatePwd',data)
}
// 消息列表
export function messagelist(param){
    return http.get('/message/messageInfo/list',param)
}
// 消息已读
export function changeReadState(messageId){
    return http.get('/message/messageInfo/changeReadState/'+messageId)
}
// 消息一键已读
export function oneClickRead(getUserId){
    return http.get('/message/messageInfo/oneClickRead/'+getUserId)
}
// 消息一键删除
export function oneClickDelete(getUserId){
    return http.delete('/message/messageInfo/oneClickDelete/'+getUserId)
}
// 底部
export function allSetInfo(param){
    return http.get('/system/config/selectAllConfigListData',param)
}
export function allmessage(getUserId){
    return http.get('/message/messageInfo/selectUserUnreadMessageCount/'+getUserId)
}
// 我的点赞列表
export function likeList(param){
    return http.get('/video/commentsLikeRecords/list',param)
}
// 我的点赞数量
export function likeNum(userId,param){
    return http.get('/video/commentsLikeRecords/getMyCommentsLikeRecordsCount/'+userId,param)
}
// 我的关注列表
export function concernList(userId,param){
    return http.get('/teacher/teacherFollowRecords/getUserTeacherFollow/'+userId,param)
}
// 2+2反馈列表
export function feedbackList(param){
    return http.get('/videoBusiness/businessCommentsExpand/study/list',param)
}
// 我的任务根据学校id获取计划
export function getplan(schoolId){
    return http.get('/plan/planInfo/selectSchoolNowPlanInfoList/'+schoolId)
}
// 我的任务根据计划id获取计划清单
export function getplanchild(planId){
    return http.get('/plan/planInfo/selectPlanManifestListByPlanId/'+planId)
}
// 我的签到列表
export function getsignList(param){
    return http.get('/live/liveInfo/findSchoolLiveList',param)
}
// 查看我的签到列表
export function getsigndetailList(param){
    return http.get('/live/signRecord/mhSignHistory',param)
}
// 查看我的签到列表
export function getresearchNum(param){
    return http.get('/research/researchInfo/portalCount',param)
}
// 查看我的证书列表
export function getcertificatelist(param){
    return http.get('/books/info/my/list',param)
}
// 添加证书/共同体学校
export function addcertificate(data){
    return http.post('/books/info/portalAdd',data)
}
// 修改证书/共同体学校
export function editcertificate(data){
    return http.post('/books/info/portalEdit',data)
}
// 删除证书/共同体学校
export function deletecertificate(id){
    return http.delete('/books/info/delzs/'+id)
}
// 共同体学校数量
export function getschollnum(param){
    return http.get('/books/info/findCount',param)
}
// 共同体学校详情
export function getschooldetail(id){
    return http.get('/books/info/'+id)
}
// 教联体活动列表
export function getunioncertificatelist(param){
    return http.get('/books/unionInfo/my/list',param)
}
// 添加教联体活动
export function addunioncertificate(data){
    return http.post('/books/unionInfo/portalAdd',data)
}
// 修改教联体活动
export function editunioncertificate(data){
    return http.post('/books/unionInfo/portalEdit',data)
}
// 删除教联体活动
export function deleteunioncertificate(id){
    return http.delete('/books/unionInfo/delzs/'+id)
}
// 教联体活动数量
export function getunionschollnum(param){
    return http.get('/books/unionInfo/findCount',param)
}
// 教联体活动详情
export function getunionschooldetail(id){
    return http.get('/books/unionInfo/'+id)
}
// 发展历程
export function getschoolhistory(param){
    return http.get('/pt/fzlc/listNoPage',param)
}
// 教研排期列表
export function getScheduleList(param){
    return http.get('/research/schedule/list',param)
}
export function getScheduleRelationList(param){
    return http.get('/research/schedule/relationList',param)
}


// WEBPACK FOOTER //
// ./src/api/study.js